export const JOYRIDE_TOURTIP_STYLES_DEFAULT = {
    options: {
        arrowColor: '#FFFFFF',
        zIndex: 201,
        beaconSize: 24,
    },
    beacon: {
        top: 8,
        left: 0,
    },
};

export const JOYRIDE_TOURTIP_FLOATER_STYLES_DEFAULT = {
    floater: {
        transition: 'opacity 0.75s ease-in-out',
    },
    floaterClosing: {
        transition: 'opacity 0.75s ease-in-out',
    },
};
